@if(showMessage){
<p-dialog id="showMessage" [modal]="true" header="Information" 
styleClass="quick-view-grid-row filterbox filter-dialog-box" [(visible)]="showMessage"
[closable]="true" appendTo="body" (onHide)="showMessage=false"  
(visibleChange)="showMessage=false">
    <span class="showMessage">{{showMessageDetails}}</span>
    <ng-template #footer>
            <p-button id="info-button" class="applyButton floatRight" icon="fa fa-check" (onClick)="showMessage=false" label="Ok"></p-button>
   </ng-template>
</p-dialog>
}

<div class="col-lg-12" [style]="{'padding-top':'2px !important','padding-left':'1px !important'}">
    <mat-chip-listbox aria-label="filter" id="filterChipBox">
        <span>
            <label for="filter" (click)="showFilter()">
                <i class="fa fa-filter" id="filter"></i>
            </label>

            @if(TempFilterData[0].label === 'Date' || TempFilterData[0].label === 'clientDataDate' || TempFilterData[0].label === 'Sample Date *' || 
            TempFilterData[0].label === 'Transaction Date' || TempFilterData[0].label === 'Order Receiving Date' || TempFilterData[0].label === 'Trade Date'){
            <ng-container>
                <button pButton type="button" class="btn-bg-color-dark-blue" (click)="selectBackDate(this.TempFilterData[0].values[0])">
                    <i class="fa fa-backward"></i>
                </button>
                <button  type="button" class="date-btn"  (click)="this.showFilter()">
                  {{this.TempFilterData[0].values[0] === this.TempFilterData[0].values[1] || this.TempFilterData[0].values[1] === null ? 
                    this.userService.getyyyyMMddDateFormate(this.TempFilterData[0].values[0]) : 
                    this.userService.getyyyyMMddDateFormate(this.TempFilterData[0].values[0]) + ',' + 
                    this.userService.getyyyyMMddDateFormate(this.TempFilterData[0].values[1])}}
                    <!-- Reg Finra Inquiry Add Inquiry Popup Filter Dialog -->
                    @if(TempFilterData[0].label === 'Transaction Date') {
                        {{this.userService.getyyyyMMddDateFormate(this.TempFilterData[4].values)}}
                    }
                    <!-- End of Reg Finra Inquiry Add Inquiry Popup Filter Dialog -->
                </button>
                <button pButton type="button" class="btn-bg-color-dark-blue" (click)="selectNextDate(this.TempFilterData[0].values[1])">
                    <i class="fa fa-forward"></i>
                </button>
            </ng-container>
            }
            
            @for (filterRow of ApliedFilterName; track filterRow.label; let l = $index){
            <a>
                @if(filterRow?.values && filterRow.label !== 'Date' && filterRow?.label !== 'clientDataDate' && 
                filterRow?.label !== 'Order Receiving Date' && TempFilterData[0]?.label !== 'Trade Date' && TempFilterData[0]?.label !== 'Transaction Date'){
                <mat-chip [removable]="true" selected
                    (click)="this.showFilter()" color="green" [matTooltip]="getToolTipValue(filterRow)"
                    [matTooltipShowDelay]="1000"
                    matTooltipPosition="after" [id]="filterRow.label" class="mat-chip-caption">
                    {{filterRow.label === 'Date' || filterRow.label === 'clientDataDate' || filterRow.label === 'Order Receiving Date' ||
                    TempFilterData[0].label === 'Trade Date'
                    ?this.TempFilterData[0].values[0] === this.TempFilterData[0].values[1] || this.TempFilterData[0].values[1] === null ? 
                    this.userService.getyyyyMMddDateFormate(this.TempFilterData[0].values[0]) : 
                    this.userService.getyyyyMMddDateFormate(this.TempFilterData[0].values[0]) + ',' + 
                    this.userService.getyyyyMMddDateFormate(this.TempFilterData[0].values[1]) : filterRow.label}}
                    @if((pageName!=='user-log' && (filterRow.datatype  | uppercase)!='DATERANGE') || (urlService.getMainTabName()==='CAIS')){
                    <mat-icon matChipRemove id="removeFilter" class="mat-chip-remove"
                        (click)="removeFilterLabel(l,filterRow)">cancel</mat-icon>
                    }
                    <sub>{{rowCount}}</sub>
                </mat-chip>
            }
            </a>}
            <!-- Opted Application Filter Display -->
             @if((ActiveApplicationFilter | json) != '{}'){
            <a>
                <mat-chip [removable]="true" selected
                    [matTooltip]="ActiveApplicationFilter.filter_query_name" matTooltipPosition="after" [matTooltipShowDelay]="1000"
                    (click)="this.showFilter()" [id]="ActiveApplicationFilter.filter_query_name">
                    {{ActiveApplicationFilter.filter_query_name}}
                    <mat-icon matChipRemove id="removeApplicationFilter"
                    (click)="removeApplicationFilter()">cancel</mat-icon>
                </mat-chip>
            </a>
            }
            <!-- End of Opted Application Filter Display -->
        </span>
    
        @if(pageName == "Comparative-Review-Report"){
        <div class="filter-row">
            <p-button class="btn-report" label="Add Custom Samples" id="add-sample-button" (onClick)="resetSampleDefault()"
                [disabled]="compReviewServiceService.isLoadingGenerateCustomSample"
                [loading]="compReviewServiceService.isLoadingGenerateCustomSample" 
                matTooltip="Add Sample Records" matTooltipPosition="below" />
            <p-button id="btn-add-random-samples" class="btn-report" matTooltip="Adding Random Sample Records"
                [disabled]="compReviewServiceService.isLoadingGeneraterandomSample"
                [loading]="compReviewServiceService.isLoadingGeneraterandomSample"
                matTooltipPosition="below" (onClick)="generateRandomSampleRecords()"
                label="Add Random Samples"></p-button>
            <p-button class="btn-report" label="Run Comparative Report" id="run-comparative-report-button"
                [loading]="compReviewServiceService.isRunCompReport" (onClick)="runComparativeReport()"
                [disabled]="compReviewServiceService.isRunCompReport || compReviewServiceService.disableRunCompReportButton" matTooltip="Run Comparative Report"
                matTooltipPosition="below" />
        </div>
        }

        @if(pageName == "Reg-Inquiry-List"){
        <div class="filter-row">
            <p-button class="btn-report" label="Add Inquiry" id="add-inquiry-button" (onClick)="addInquiryDialog()"
                [disabled]="FinraInquiryServiceService.isLoadingAddingFinraInquiry"
                [loading]="FinraInquiryServiceService.isLoadingAddingFinraInquiry" 
                icon="fa fa-plus" matTooltip="Add Inquiry" matTooltipPosition="below" />
        </div>
        }
    </mat-chip-listbox>

</div>


<!-- Filter Panel Code -->
  @if(displayFilter){
<p-dialog id="filter-dialog" [modal]="true" [header]="filterHeader" 
styleClass="quick-view-grid-row filterbox filter-dialog-box" [(visible)]="displayFilter"
maximizeIcon="pi pi-window-maximize" closeIcon="pi pi-times"  
[closable]="true" appendTo="body" (onHide)="closeFilterDialog()"  
(visibleChange)="closeFilterDialog()">

    <!-- Save Filter Query -->
     @if(FilterAccessibleApplications.includes(pageName)){
         @if(pageName != "Comparative-Review-Report"){
        <div class="ui-g">
            <div class="ui-g-1 padding-4"></div>
            <div class="ui-g-5 padding-4 p-field-checkbox">
                <p-checkbox ngDefaultControl name="save_filter" [(ngModel)]="isSaveFilter" binary="true" 
                class="saveFilterCheckbox"></p-checkbox>
                <label for="Save Filter">Save Filter</label>
            </div>
            <div class="ui-g-5" style="padding: 0;">
                <input [name]="'saved_filter_name'" [id]="'saved_filter_name'" [(ngModel)]="savedFilterQuaryName" type="text" placeholder="Save/Save As" style="width:100%; margin-top: 4px;" maxlength="15" pInputText />
            </div>
            <div class="ui-g-1 padding-4"></div>
        </div>
        }
        @if(isAddSamples){
            <div class="card flex justify-center gap-1">
                <div class="ui-g">
                    <div class="ui-g-3">
                        <label for="Save Sample">Sample Name <sup>*</sup></label>
                    </div>
                    <div class="ui-g-5" style="padding: 0;">
                        <input name="saved_sample_name" id="saved_sample_name"
                            [(ngModel)]="compReviewServiceService.customSampleName" type="text" placeholder="Sample Name"
                            (keyup)="onKeyPress('samplename',compReviewServiceService.customSampleName,'')"
                            style="width:100%; margin-top: 4px;" maxlength="15" pInputText />
                    </div>
                    <div class="ui-g-4">
                         <label for="sampleLabelName" class="sampleLabelName">
                     <p-checkbox inputId="save_sample" name="save_sample" value="isSaveFilter"
                        [(ngModel)]="isSaveFilter" />
                     Save Sample
                    </label>
                    </div>
                </div>
            </div>
        }
    }
    <!-- End of Save Filter Query -->
<div class="card flex justify-center gap-1">     
    <div class="ui-g panelTitles">
        <div class="ui-g-4 padding-4">Columns Name</div>
        <div class="ui-g-3 padding-4">Filter</div>
        <div class="ui-g-4 padding-4">Value</div>
        <div class="ui-g-1 padding-4"></div>
    </div>
    <div>
        @for (filterRow of TempFilterData; track filterRow.label; let f = $index){
        @if(!filterRow?.isDisplay){
            <div class="ui-g" style="font-size: 12px;">
            <!-- Filter Name -->
            <div class="ui-g-4 padding-4">
                @if((filterRow?.isdefault | lowercase)!='true' && filterRow?.columnname){
                <p-select id="filterDrpbyName"
                    [ngClass]="filterRow?.disabled == true ? 'cursor-not-allowed' : 'default '" autofocus
                    required="true" name="columnname" [(ngModel)]="filterRow.columnname" [options]="filterCols"
                    appendTo="body" [style]="{ 'text-transform': 'capitalize','overflow':'visible','width':'100%',
                        'border-radius':'0','padding':'0 !important','height':'23px', 'margin-bottom': '5px'
                    }"
                    [title]="filterRow.label" placeholder="{{filterRow?.label}}" filter="true"
                    (onChange)="getFilterDataType(filterCols[f],f)" styleClass="filter-dropdown">
                    <ng-template let-filterCols let-row let-i="index" pTemplate="item">
                        <div id="getFilterByType" 
                            class="ui-helper-clearfix" clickable>
                            <div [id]="filterCols.label">{{(filterCols.label) | titlecase}}</div>
                        </div>
                    </ng-template>
                </p-select>
                }

                @if((filterRow?.isdefault | lowercase)=='true' && isDatefilterDropdown){
                <div>
                    @if(filterRow?.label !== 'clientDataDate'){
                    <input id="filterNameInp" disabled [(ngModel)]="filterRow.label" 
                    style="width:100% !important;margin-bottom: 5px !important;" />
                    }
                    @if(filterRow?.label === 'clientDataDate'){
                    <p-select
                     id="filterDrpbydate" autofocus name="filterby"
                    [options]="filterRow?.dateDropDown" [(ngModel)]="filterRow.dateFilterBy" 
                    (ngModelChange)="changeFilterDataType(filterRow)" 
                    appendTo="body" placeholder="{{filterRow?.dateFilterBy}}"
                    [style]="{'z-index': '1089', 'text-transform': 'capitalize','overflow':'visible','width':'100%',
                        'padding':'0 !important','height':'23px'}" styleClass="filter-dropdown">
                    <ng-template let-filterCols pTemplate="item">
                        <div class="ui-helper-clearfix">
                            <div [id]="filterCols.label">{{filterCols.label | titlecase}}</div>
                        </div>
                    </ng-template>
                </p-select>
                }
                </div>
                }

                @if((filterRow?.isdefault | lowercase)=='true' && !isDatefilterDropdown){
                <div>
                    @if(filterRow?.label !== 'clientDataDate'){
                    <input id="filterNameInp" disabled [(ngModel)]="filterRow.label" 
                    [title]="filterRow.label" style="width:100% !important; color:#000 !important" />
                    }
                </div>
                }
            </div>
            <!-- Filter By Type -->
            <div class="ui-g-2 padding-4 ">
                @if(pageName !== 'user-log' &&(filterRow?.datatype | lowercase)=='string' || (filterRow?.datatype | lowercase)=='char' || (filterRow?.datatype | lowercase)=='skip'){
                <p-select  id="filterDrpbyTypeChar" autofocus required="true" name="filterby"
                    [options]="(filterRow.isNeededOwnFilterOptions ? applyCustomerFilterOptions(filterByString, filterRow) : filterByString)" [(ngModel)]="filterRow.filterby" appendTo="body"
                    placeholder="{{filterRow?.filterby}}" (onChange)="filterRow.isNeededOwnFilterOptions && onChangeFieldDataType(filterRow)"
                    [style]="{'z-index': '1089', 'text-transform': 'capitalize','overflow':'visible','width':'100%',
                        'border-radius':'0','padding':'0 !important','height':'23px'
                    }" styleClass="filter-dropdown">
                    <ng-template let-filterCols pTemplate="item">
                        <div class="ui-helper-clearfix">
                            <div [id]="filterCols.label">{{filterCols.label | titlecase}}</div>
                        </div>
                    </ng-template>
                </p-select>
                }
                @if((filterRow?.datatype | lowercase)=='int' || (filterRow?.datatype | lowercase)=='float' || (filterRow?.datatype | lowercase)=='datetime'){
                <p-select id="filterDrpbyTypeInt" autofocus required="true" name="filterby"
                    [options]="(filterRow.isNeededOwnFilterOptions ? applyCustomerFilterOptions(filterByInt, filterRow) : filterByInt)" [(ngModel)]="filterRow.filterby" appendTo="body"
                    placeholder="{{filterRow?.filterby}}" (onChange)="filterRow.isNeededOwnFilterOptions && onChangeFieldDataType(filterRow)"
                    [style]="{'z-index': '1089', 'text-transform': 'capitalize','overflow':'visible','width':'100%',
                        'border-radius':'0','padding':'0 !important','height':'23px'
                    }" styleClass="filter-dropdown">
                    <ng-template let-filterCols pTemplate="item">
                        <div class="ui-helper-clearfix">
                            <div [id]="filterCols.label" [matTooltipShowDelay]="1000" [matTooltip]="filterCols?.description" matTooltipPosition="after">
                                {{filterCols?.label | titlecase}}</div>
                        </div>
                    </ng-template>
                </p-select>
                }
                @if((filterRow?.datatype | lowercase)=='boolean'){
                <div>
                    <input id="filterby" name="filterRow.filterby" disabled [(ngModel)]="filterRow.filterby" [ngStyle]="{'width':'100%','text-align':'center'}" />
                </div>
                }
            </div>
            <!-- Filter Values -->
            <div class="ui-g-5 padding-4">
                @if((filterRow?.dropdown | lowercase)=='yes'){
                <div>
                    <!-- Filter Dropdown 4 Single Select  -->
                    @if((filterRow?.dropdowntype | lowercase)=='singleselect'){
                    <p-select id="filterDrpbyTypeSingleSelect" [showClear]="true" name="filterDrpbyTypeSingleSelect"
                        [options]="filterRow?.dropdownvalue" [(ngModel)]="filterRow.values" placeholder="Please Select"
                        appendTo="body" [style]="{'text-transform': 'capitalize','width':'100%',
                            'border-radius':'0','padding':'0 !important','height':'23px'
                        }" required="true" styleClass="filter-dropdown">
                        <ng-template let-filterCols pTemplate="item">
                            <div class="ui-helper-clearfix singleSelectDropdownOptions">
                                <div [id]="filterCols.label" [matTooltip]="filterCols?.description" [matTooltipShowDelay]="1000" matTooltipPosition="after">
                                    {{filterCols?.label}}</div>
                            </div>
                        </ng-template>
                    </p-select>
                    } 
                    <!-- Filter Dropdown 4 Multiple Select  -->
                     @if((filterRow?.dropdowntype | lowercase)=='multiselect'){
                    <p-multiSelect id="filterDrpbyTypeMultiSelect" name="filterDrpbyTypeMultiSelect"
                        class="col-lg-2 padding-4 padding-4"
                        [options]="filterRow?.dropdownvalue"
                        [autofocus] = "true"
                        [required]="filterRow?.label === 'type : true : false'"
                        [(ngModel)]="filterRow.values" appendTo="body" 
                        [filter]="true" 
                        styleClass = "filter-multiselect"
                        [style]="{ 'text-transform': 'capitalize','overflow':'visible','width':'30%'}"
                        placeholder="Choose" 
                        panelStyleClass = "Filter-multiselect-dropdownPanel"/>
                    }
                </div>
                }
                @if((filterRow?.datatype | lowercase)=='boolean'){
                <div>
                 <p-select id="filterDrpbyTypeBoolean" name="filterDrpbyTypeBoolean" autofocus required="true" name="filtervalue"
                    [options]="filterByBoolean" [(ngModel)]="filterRow.values" appendTo="body"
                    placeholder="Select Value"
                    [showClear]="true"
                    [style]="{'z-index': '1089', 'text-transform': 'capitalize','overflow':'visible','width':'100%',
                        'border-radius':'0','padding':'0 !important','height':'23px'
                    }" styleClass="filter-dropdown">
                    <ng-template let-filterCols pTemplate="item">
                        <div class="ui-helper-clearfix">
                            <div [id]="filterCols.label" [matTooltipShowDelay]="1000" [matTooltip]="filterCols?.description" matTooltipPosition="after">
                                {{filterCols?.label}}</div>
                        </div>
                    </ng-template>
                </p-select>
                </div>
                }
                @if((filterRow?.datatype | lowercase)=='daterange'){
                <div>                    
                    <app-datepicker-calendar [dateRange]="filterRow.values" [isDateRange]="true" (dateChange)="getDateEmitter($event,filterRow,f)"></app-datepicker-calendar>
                </div>
                }
                @if((filterRow?.datatype | lowercase)=='datetime' && (filterRow?.dropdown | lowercase)!= 'yes'){
                <div>
                    <app-datepicker-calendar [dateRange]="filterRow.values" [isDateRange]="true" (dateChange)="getDateEmitter($event,filterRow,f)"></app-datepicker-calendar>
                </div>
                }
                @if((filterRow?.datatype | lowercase)=='date'){
                <div>
                    <app-datepicker-calendar [date]="filterRow.values" [isDateRange]="false" (dateChange)="getDateEmitter($event,filterRow,f)"></app-datepicker-calendar>
                </div>
                }
                @if((filterRow?.datatype )=='clientDataSingleDate'){
                <div>
                    <app-datepicker-calendar [date]="filterRow.dateFilterValue" [isDateRange]="false" (dateChange)="getDateEmitter($event,filterRow,f)"></app-datepicker-calendar>
                </div>
                }

                @if((filterRow?.datatype  | lowercase)=='time' || (filterRow?.datatype  | lowercase)=='starttime' || (filterRow?.datatype  | lowercase)=='endtime'){
                <div>
                    <p-select id="filterDrpTime" name="filterDrpTime" [options]="TimeDropDown" [(ngModel)]="filterRow.values" appendTo="body"
                        [style]="{'text-transform': 'capitalize','width':'100%',
                            'border-radius':'0','padding':'0 !important','height':'23px'
                        }" placeholder="Select Time "
                        required="true" styleClass="filter-dropdown">
                        <ng-template let-filterCols let-row pTemplate="item">
                            <div (change)="FormateDate(filterRow?.values,f,filterRow?.datatype)"
                                class="ui-helper-clearfix" [style]="{'text-transform':'capitalize'}">
                                <div [id]="filterCols.label">{{filterCols.label}}</div>
                            </div>
                        </ng-template>
                    </p-select>
                </div>
                }
                @if((filterRow?.datatype  | lowercase)=='string' && (filterRow?.dropdown  | lowercase)!='yes' || (filterRow?.datatype  | lowercase)=='char'){
                <div>
                    <input id="filterByDataTypeString" required name="value" type="text" [(ngModel)]="filterRow.values"
                        [style]="{'width':'100% !important'}" [placeholder]=filterRow?.values (keydown.enter)="applyFilter()" (keyup)="onKeyPress(filterRow.label,filterRow.values,f)" />
                </div>
                }
                @if((filterRow?.datatype  | lowercase)=='int'  && (filterRow?.dropdown  | lowercase)!='yes' || (filterRow?.datatype  | lowercase)=='float'){
                <div>
                    <input id="filterByDataTypeInt" autofocus ng-pattern="/^[0-9]$/" required name="value" type="number"
                        [(ngModel)]="filterRow.values" [style]="{'width':'100% !important'}" [placeholder]=filterRow?.values (keydown.enter)="applyFilter()" />
                </div>
                }
            </div>
            <div class="ui-g-1" style="color: #fff;">
                @if((filterRow?.isdefault | lowercase)!='true'){
                <p-button class="filterRomoveBtn" color="warn" icon="fa fa-close"
                    (onClick)="removeFilterTemp(f)" [style]="{'margin':'15px !important'}"></p-button>
                }
            </div>
            </div>
        }
        }
    </div>
    @if(displayUserInfo){
    <div class="card flex justify-center gap-4" >
        <div class="ui-g-12">
           
                <div class="ui-grid-col-12">
                    <label for="ui_Field_Name">Updated User: </label> {{updatedUser}}
                </div>
           
          
                <div class="ui-grid-col-12">
                    <label for="ui_Field_Name" class="label-day-fo-week">Updated at: </label> {{updatedDate}}
                </div>
        </div>
    </div>
    }
</div>    
    <ng-template #footer>
        <div class="ui-dialog-buttonpane ui-helper-clearfix">
            @if(isAddFilter){
            <p-button id="addFilter" class="floatLeft applyButton" icon="fa fa-plus"
                (onClick)="addFilterRow()" label="Add Field"></p-button>
            }
            @if(isAddSamples){
            <p-button id="btn-add-custom-samples" class="applyButton floatRight" matTooltip="Adding Custom Sample Records"
                [disabled]="compReviewServiceService.customSampleName == ''"
                [loading]="compReviewServiceService.isLoadingGenerateCustomSample"
                matTooltipPosition="below" (onClick)="generateCustomSampleRecords()"
                label="Add Custom Samples"></p-button>
        
            }
            @else if(isAddInquiry){
                <p-button id="btn-add-inquiry" class="applyButton floatRight" [matTooltip]="isOpenFilterDialog ? 'Updating Inquiry' : 'Adding Inquiry'"
                    [loading]="FinraInquiryServiceService.isLoadingAddingFinraInquiry"
                    matTooltipPosition="below" (onClick)="addInquiryDetail(false)"
                    [label]="isOpenFilterDialog ? 'Edit Inquiry' : 'Add Inquiry'"></p-button>

                <p-button id="btn-add-inquiry-with-result" class="applyButton floatRight" [matTooltip]="isOpenFilterDialog ? 'Edit Inquiry with Result' : 'Add Inquiry with Result'"
                    [loading]="FinraInquiryServiceService.isLoadingAddingFinraInquiry"
                    matTooltipPosition="below" (onClick)="addInquiryDetail(true)"
                    [label]="isOpenFilterDialog ? 'Edit Inquiry with Result' : 'Add Inquiry with Result'"></p-button>
            }
            @else{
            <p-button id="applyFilter" class="applyButton floatRight" icon="fa fa-check" (onClick)="applyFilter()" label="Apply Filters"></p-button>
            }
        </div>
   </ng-template>
</p-dialog>
}